import useApi from '../../../services/useApi'

const useGetCategories = () => {
  const Api = useApi()
  const {data: response, isFetching} = Api.useGetQuery('/products/product-badges/categories/treeview')

  return {
    allCategories: response?.data || [],
    isLoading: isFetching,
  }
}

export default useGetCategories
